/**
 * GABRIEL — Luxury Jewelry & Watches Theme
 * Vanilla JS (replaces React + Framer Motion)
 */

(function () {
  'use strict';

  // ============================================================
  // 1. UTILITIES
  // ============================================================
  function $(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function $$(sel, ctx) {
    return [...(ctx || document).querySelectorAll(sel)];
  }

  function formatMoney(cents) {
    const euros = cents / 100;
    const isWhole = euros % 1 === 0;
    return (
      '€' +
      euros.toLocaleString('de-DE', {
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2,
      }) +
      ',-'
    );
  }

  function formatDrawerMoney(cents) {
    const euros = Number(cents || 0) / 100;
    const isWhole = euros % 1 === 0;
    return (
      '€ ' +
      euros.toLocaleString('de-DE', {
        minimumFractionDigits: isWhole ? 0 : 2,
        maximumFractionDigits: 2,
      })
    );
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function createOffcanvasController() {
    const body = document.body;
    const root = document.documentElement;
    const panelState = new WeakMap();

    function getScrollbarWidth() {
      return Math.max(0, window.innerWidth - root.clientWidth);
    }

    function getFocusableElements(container) {
      return $$(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
        container,
      ).filter(function (element) {
        return !element.hasAttribute('hidden') && !element.closest('[hidden]');
      });
    }

    function syncBodyLock(forceLocked) {
      const isLocked = typeof forceLocked === 'boolean' ? forceLocked : !!getOpenPanel();
      const scrollbarWidth = isLocked ? getScrollbarWidth() : 0;
      root.style.setProperty('--offcanvas-scrollbar-width', scrollbarWidth + 'px');
      body.classList.toggle('offcanvas-open', isLocked);
    }

    function getPanel(name) {
      return document.querySelector('[data-offcanvas="' + name + '"]');
    }

    function getOpenPanel() {
      return document.querySelector('.site-offcanvas.is-open');
    }

    function restoreFocus(panel) {
      const state = panelState.get(panel);
      if (!state || !state.trigger || typeof state.trigger.focus !== 'function') return;
      requestAnimationFrame(function () {
        state.trigger.focus();
      });
    }

    function closePanel(panel, options) {
      const settings = options || {};
      if (!panel) return;
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');

      setTimeout(function () {
        if (!panel.classList.contains('is-open')) {
          panel.setAttribute('hidden', '');
          syncBodyLock();
          if (settings.restoreFocus !== false) {
            restoreFocus(panel);
          }
          document.dispatchEvent(
            new CustomEvent('site:offcanvas:close', {
              detail: { panel: panel },
            }),
          );
        }
      }, 420);
    }

    function closeAll(exceptPanel, options) {
      $$('.site-offcanvas.is-open').forEach(function (panel) {
        if (panel !== exceptPanel) {
          closePanel(panel, options);
        }
      });
    }

    function openByName(name, trigger) {
      const panel = getPanel(name);
      if (!panel) return;
      closeAll(panel, { restoreFocus: false });
      panelState.set(panel, {
        trigger: trigger || document.activeElement,
      });
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      syncBodyLock(true);

      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        const focusTarget = getFocusableElements(panel.querySelector('.site-offcanvas__panel') || panel)[0];
        if (focusTarget && typeof focusTarget.focus === 'function') {
          focusTarget.focus();
        }
        document.dispatchEvent(
          new CustomEvent('site:offcanvas:open', {
            detail: { name: name, panel: panel },
          }),
        );
      });
    }

    function closeByName(name) {
      closePanel(getPanel(name));
    }

    document.addEventListener('click', function (e) {
      const toggle = e.target.closest('[data-offcanvas-toggle]');
      if (toggle) {
        e.preventDefault();
        openByName(toggle.dataset.offcanvasToggle, toggle);
        return;
      }

      const closeTrigger = e.target.closest('[data-offcanvas-close]');
      if (closeTrigger) {
        const panel = closeTrigger.closest('.site-offcanvas');
        closePanel(panel);
      }
    });

    document.addEventListener('keydown', function (e) {
      const openPanel = getOpenPanel();
      if (!openPanel) return;

      if (e.key === 'Escape') {
        closeAll();
        return;
      }

      if (e.key !== 'Tab') return;

      const focusable = getFocusableElements(openPanel.querySelector('.site-offcanvas__panel') || openPanel);
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    });

    window.addEventListener(
      'resize',
      function () {
        if (body.classList.contains('offcanvas-open')) {
          syncBodyLock(true);
        }
      },
      { passive: true },
    );

    return {
      open: openByName,
      close: closeByName,
      closeAll: closeAll,
      isOpen: function (name) {
        const panel = getPanel(name);
        return !!(panel && panel.classList.contains('is-open'));
      },
    };
  }

  // ============================================================
  // 2. STICKY HEADER
  // ============================================================
  function initStickyHeader() {
    const header = $('#site-header');
    if (!header) return;

    const hasHero = !!$('[data-hero-slider]');

    function updateHeader() {
      if (hasHero && window.scrollY < 20) {
        header.classList.add('is-top');
        header.classList.remove('is-scrolled');
      } else {
        header.classList.remove('is-top');
        header.classList.add('is-scrolled');
      }
    }

    // Set body padding to header height always
    function updateBodyPadding() {
      const h = header.getBoundingClientRect().height;
      document.body.style.paddingTop = h + 'px';
      document.documentElement.style.setProperty('--header-h', h + 'px');
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    window.addEventListener('resize', updateBodyPadding, { passive: true });
    updateHeader();
    updateBodyPadding();
  }

  // ============================================================
  // 3. MOBILE MENU
  // ============================================================
  function initMobileMenu() {
    const btn = $('#mobile-menu-toggle');
    const closeBtn = $('#mobile-menu-close');
    const nav = $('#mobile-nav');
    const subtoggles = $$('[data-mobile-subtoggle]', nav);
    let lastFocusedElement = null;
    if (!btn || !nav) return;

    function getFocusableElements() {
      return $$(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])',
        nav,
      ).filter(function (element) {
        return !element.hasAttribute('hidden') && !element.closest('[hidden]');
      });
    }

    function closeSubmenus(exceptBtn) {
      subtoggles.forEach(function (toggle) {
        if (exceptBtn && toggle === exceptBtn) return;
        toggle.setAttribute('aria-expanded', 'false');
        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        if (panel) panel.setAttribute('hidden', '');
      });
    }

    function openMenu() {
      lastFocusedElement = document.activeElement;
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      btn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('mobile-menu-open');
      const firstFocusable = closeBtn || getFocusableElements()[0] || nav;
      requestAnimationFrame(function () {
        if (firstFocusable && typeof firstFocusable.focus === 'function') {
          firstFocusable.focus();
        }
      });
    }

    function closeMenu() {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      btn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');
      closeSubmenus();
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        requestAnimationFrame(function () {
          lastFocusedElement.focus();
        });
      }
    }

    btn.addEventListener('click', function () {
      if (nav.classList.contains('is-open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    subtoggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const panelId = toggle.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        closeSubmenus(toggle);
        toggle.setAttribute('aria-expanded', String(!isExpanded));
        if (panel) {
          if (isExpanded) {
            panel.setAttribute('hidden', '');
          } else {
            panel.removeAttribute('hidden');
          }
        }
      });
    });
    nav.addEventListener('click', function (event) {
      const target = event.target.closest('a, button[data-offcanvas-toggle]');
      if (target) closeMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (!nav.classList.contains('is-open')) return;

      if (e.key === 'Escape') {
        closeMenu();
        return;
      }

      if (e.key !== 'Tab') return;

      const focusable = getFocusableElements();
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      const active = document.activeElement;

      if (e.shiftKey && active === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && active === last) {
        e.preventDefault();
        first.focus();
      }
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 768 && nav.classList.contains('is-open')) closeMenu();
    });
  }

  // ============================================================
  // 4. MEGA MENU
  // ============================================================
  function initMegaMenu() {
    const header = $('#site-header');
    const navItems = $$('.site-header__nav-item.has-mega-menu');

    // Position mega-menu below the full header height
    function setMegaMenuTop() {
      if (!header) return;
      const h = header.getBoundingClientRect().height;
      navItems.forEach(function (item) {
        const panel = item.querySelector('.mega-menu');
        if (panel) panel.style.top = h + 'px';
      });
    }

    setMegaMenuTop();
    window.addEventListener('resize', setMegaMenuTop, { passive: true });

    navItems.forEach(function (item) {
      const panel = item.querySelector('.mega-menu');
      if (!panel) return;

      let timer;

      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        setMegaMenuTop();
        panel.removeAttribute('hidden');
        item.classList.add('is-open');
      });

      item.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          item.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }, 100);
      });

      panel.addEventListener('mouseenter', function () {
        clearTimeout(timer);
      });

      panel.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          item.classList.remove('is-open');
          panel.setAttribute('hidden', '');
        }, 100);
      });
    });
  }

  // ============================================================
  // 5. HERO SLIDER
  // ============================================================
  function initHeroSlider() {
    const slider = $('[data-hero-slider]');
    if (!slider) return;

    const slides = $$('[data-slide]', slider);
    const dots = $$('[data-dot]', slider);
    const prevBtn = $('[data-slider-prev]', slider);
    const nextBtn = $('[data-slider-next]', slider);
    const toggleBtn = $('[data-slider-toggle]', slider);
    const counterCurrent = $('[data-counter-current]', slider);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const INTERVAL = Math.max(3000, Number(slider.dataset.autoplaySpeed || 8000));
    let current = 0;
    let autoTimer;
    let touchStartX = 0;
    let touchStartY = 0;
    let isPaused = prefersReducedMotion.matches || slides.length < 2;

    function updateControls() {
      dots.forEach(function (dot, index) {
        const isActive = index === current;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });

      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-active', index === current);
        slide.setAttribute('aria-hidden', String(index !== current));
      });

      if (counterCurrent) {
        counterCurrent.textContent = String(current + 1).padStart(2, '0');
      }

      if (toggleBtn) {
        toggleBtn.setAttribute('aria-pressed', String(isPaused));
        toggleBtn.setAttribute('aria-label', isPaused ? 'Autoplay starten' : 'Autoplay pausieren');
        toggleBtn.textContent = isPaused ? 'Autoplay starten' : 'Autoplay pausieren';
      }
    }

    function stopAuto() {
      clearInterval(autoTimer);
      autoTimer = null;
    }

    function startAuto() {
      stopAuto();
      if (isPaused || slides.length < 2) return;
      autoTimer = setInterval(function () {
        goTo(current + 1);
      }, INTERVAL);
    }

    function setPaused(nextPaused) {
      isPaused = nextPaused;
      updateControls();
      startAuto();
    }

    function goTo(index) {
      current = (index + slides.length) % slides.length;
      updateControls();
    }

    if (prevBtn)
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        startAuto();
      });
    if (nextBtn)
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
        startAuto();
      });

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function () {
        setPaused(!isPaused);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.dot, 10));
        startAuto();
      });
    });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        goTo(current - 1);
        startAuto();
      }
      if (e.key === 'ArrowRight') {
        goTo(current + 1);
        startAuto();
      }
      if ((e.key === ' ' || e.key === 'Spacebar') && toggleBtn) {
        e.preventDefault();
        setPaused(!isPaused);
      }
    });

    slider.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true },
    );

    slider.addEventListener(
      'touchend',
      function (event) {
        if (!event.changedTouches.length) return;
        const deltaX = event.changedTouches[0].clientX - touchStartX;
        const deltaY = event.changedTouches[0].clientY - touchStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        goTo(deltaX < 0 ? current + 1 : current - 1);
        startAuto();
      },
      { passive: true },
    );

    function handleReducedMotionChange(event) {
      setPaused(event.matches || slides.length < 2);
    }

    if (typeof prefersReducedMotion.addEventListener === 'function') {
      prefersReducedMotion.addEventListener('change', handleReducedMotionChange);
    } else if (typeof prefersReducedMotion.addListener === 'function') {
      prefersReducedMotion.addListener(handleReducedMotionChange);
    }

    updateControls();
    startAuto();
  }

  // ============================================================
  // 6. SCROLL ANIMATIONS (IntersectionObserver)
  // ============================================================
  function showAllSections() {
    $$('.section-animate').forEach(function (el) {
      el.classList.add('in-view');
    });
  }

  function initScrollAnimations() {
    // In Theme Editor: disable animations entirely so sections are always visible
    if (Shopify.designMode) {
      showAllSections();
      // Also handle sections loaded/reloaded via Theme Editor events
      document.addEventListener('shopify:section:load', function () {
        showAllSections();
      });
      document.addEventListener('shopify:section:reorder', function () {
        showAllSections();
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      showAllSections();
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' },
    );

    $$('.section-animate').forEach(function (el) {
      observer.observe(el);
    });
  }

  // ============================================================
  // 7. CART DRAWER (Shopify Ajax Cart API)
  // ============================================================
  function initCartDrawer(offcanvas) {
    const drawer = $('#cart-drawer');
    if (!drawer) return;

    const itemsEl = $('#cart-drawer-items');
    const footerEl = $('#cart-drawer-footer');
    const emptyEl = $('#cart-drawer-empty');
    const benefitsEl = $('#cart-drawer-benefits');
    const subtotalEl = $('#cart-drawer-subtotal');
    const totalEl = $('#cart-drawer-total');
    const titleCountEl = $('#cart-drawer-count');
    const cartCountEls = $$('#cart-count, [data-cart-count]');

    // Fetch cart and render
    function fetchCart() {
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(renderCart)
        .catch(function (err) {
          console.error('Cart fetch error', err);
        });
    }

    function renderCart(cart) {
      // Update count
      cartCountEls.forEach(function (el) {
        el.textContent = cart.item_count;
        if (cart.item_count > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });
      if (titleCountEl) titleCountEl.textContent = '(' + cart.item_count + ')';

      if (cart.item_count === 0) {
        if (itemsEl) itemsEl.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        if (footerEl) footerEl.setAttribute('hidden', '');
        if (benefitsEl) benefitsEl.hidden = false;
        return;
      }

      if (emptyEl) emptyEl.hidden = true;
      if (footerEl) footerEl.removeAttribute('hidden');
      if (benefitsEl) benefitsEl.hidden = true;

      function buildCartPropertiesMarkup(item) {
        if (!item || !item.properties) return '';

        const entries = Object.entries(item.properties).filter(function (entry) {
          const key = entry[0];
          const value = entry[1];
          return key && key.charAt(0) !== '_' && value != null && String(value).trim() !== '';
        });

        if (!entries.length) return '';

        return entries
          .map(function (entry) {
            return (
              '<p class="cart-drawer__item-property"><span>' +
              escapeHtml(entry[0]) +
              ':</span> ' +
              escapeHtml(entry[1]) +
              '</p>'
            );
          })
          .join('');
      }

      // Build items HTML
      const itemsHTML = cart.items
        .map(function (item) {
          const image = item.image || (item.featured_image && item.featured_image.url) || '';
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
          const category = item.product_type || item.vendor || variant || 'Schmuck';
          const sizeLabel = variant ? 'Größe: ' + variant : '&nbsp;';
          const propertiesMarkup = buildCartPropertiesMarkup(item);
          return `
          <div class="cart-drawer__item" data-line="${item.key}">
            <div class="cart-drawer__item-img-wrap">
              ${
                image
                  ? `<img class="cart-drawer__item-img"
                src="${image}"
                alt="${item.title}"
                width="140" height="140"
                loading="lazy"
              >`
                  : '<div class="cart-drawer__item-img cart-drawer__item-img--placeholder"></div>'
              }
            </div>
            <div class="cart-drawer__item-info">
              <div class="cart-drawer__item-meta">
                <div class="cart-drawer__item-copy">
                  <p class="cart-drawer__item-brand">${escapeHtml(category)}</p>
                  <p class="cart-drawer__item-title">${item.product_title}</p>
                  <p class="cart-drawer__item-material">${sizeLabel}</p>
                  ${propertiesMarkup}
                  <p class="cart-drawer__item-price">${formatDrawerMoney(item.final_line_price)}</p>
                </div>
                <button class="cart-drawer__item-remove" data-remove="${item.key}" aria-label="Entfernen">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                </button>
              </div>
              <div class="cart-drawer__item-qty">
                <div class="cart-drawer__qty-controls">
                  <button class="cart-drawer__qty-btn" data-qty-decrease="${item.key}" aria-label="Weniger">−</button>
                  <span class="cart-drawer__qty-num">${item.quantity}</span>
                  <button class="cart-drawer__qty-btn" data-qty-increase="${item.key}" aria-label="Mehr">+</button>
                </div>
              </div>
            </div>
          </div>
        `;
        })
        .join('');

      if (itemsEl) itemsEl.innerHTML = itemsHTML;

      const formattedTotal = formatDrawerMoney(cart.total_price);
      if (subtotalEl) subtotalEl.textContent = formattedTotal;
      if (totalEl) totalEl.textContent = formattedTotal;

      // Bind remove buttons
      $$('[data-remove]', drawer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          updateCartItem(btn.dataset.remove, 0);
        });
      });

      // Bind qty buttons
      $$('[data-qty-decrease]', drawer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          const itemEl = btn.closest('.cart-drawer__item');
          const qtyEl = itemEl && itemEl.querySelector('.cart-drawer__qty-num');
          const qty = qtyEl ? parseInt(qtyEl.textContent) - 1 : 0;
          updateCartItem(btn.dataset.qtyDecrease, Math.max(0, qty));
        });
      });

      $$('[data-qty-increase]', drawer).forEach(function (btn) {
        btn.addEventListener('click', function () {
          const itemEl = btn.closest('.cart-drawer__item');
          const qtyEl = itemEl && itemEl.querySelector('.cart-drawer__qty-num');
          const qty = qtyEl ? parseInt(qtyEl.textContent) + 1 : 1;
          updateCartItem(btn.dataset.qtyIncrease, qty);
        });
      });
    }

    function updateCartItem(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(renderCart)
        .catch(function (err) {
          console.error('Cart update error', err);
        });
    }

    // Add to cart from product card buttons
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      e.preventDefault();
      const variantId = btn.dataset.addToCart;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          // Fetch updated cart first, render it, then open the drawer
          return fetch('/cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              renderCart(cart);
              offcanvas.open('cart');
            });
        })
        .catch(function (err) {
          console.error('Add to cart error', err);
        });
    });

    // Product page form (supports both old id and new pdp-form id)
    const productForm = $('#pdp-form') || $('#product-form');
    if (productForm) {
      const ringSizeSelect = $('[data-ring-size-select]', productForm);
      const ringSizeError = $('[data-ring-size-error]', productForm);

      function syncRingSizeValidity() {
        if (!ringSizeSelect) return true;

        const hasValue = !!String(ringSizeSelect.value || '').trim();
        ringSizeSelect.setAttribute('aria-invalid', hasValue ? 'false' : 'true');
        if (ringSizeError) ringSizeError.hidden = hasValue;
        return hasValue;
      }

      if (ringSizeSelect) {
        ringSizeSelect.addEventListener('change', syncRingSizeValidity);
        ringSizeSelect.addEventListener('input', syncRingSizeValidity);
      }

      productForm.addEventListener('submit', function (e) {
        e.preventDefault();

        if (ringSizeSelect && !syncRingSizeValidity()) {
          ringSizeSelect.focus();
          return;
        }

        const formData = new FormData(productForm);
        const submitBtn = productForm.querySelector('[type="submit"]');
        const originalText = submitBtn ? submitBtn.textContent : null;

        if (!formData.get('quantity')) {
          formData.append('quantity', '1');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            var ringSizeValue = ringSizeSelect && ringSizeSelect.value ? String(ringSizeSelect.value).trim() : null;
            if (ringSizeValue) {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ note: 'Ringgröße: ' + ringSizeValue }),
              });
            }
          })
          .then(function () {
            fetchCart();
            if (submitBtn) {
              submitBtn.textContent = 'Hinzugefügt ✓';
              setTimeout(function () {
                submitBtn.textContent = originalText;
              }, 2000);
            }
          })
          .catch(function (err) {
            console.error('Add to cart error', err);
          });
      });
    }

    document.addEventListener('site:offcanvas:open', function (e) {
      if (e.detail.name === 'cart') {
        fetchCart();
      }
    });

    fetchCart();
  }

  // ============================================================
  // 8. SEARCH OFFCANVAS
  // ============================================================
  function initSearchOffcanvas() {
    const panel = $('#search-offcanvas');
    const input = $('[data-search-offcanvas-input]');
    const form = input && input.closest('form');
    const defaultSections = $$('[data-search-default-section]', panel);
    const recentSection = $('[data-recent-searches-section]', panel);
    const recentList = $('[data-recent-searches-list]', panel);
    const recentEmptyMessage = $('[data-recent-searches-empty]', panel);
    const liveSection = $('[data-live-search-section]', panel);
    const liveCount = $('[data-live-search-count]', panel);
    const liveLoading = $('[data-live-search-loading]', panel);
    const liveStatus = $('[data-live-search-status]', panel);
    const liveProductBlock = $('[data-live-search-product-block]', panel);
    const liveProductList = $('[data-live-search-product-list]', panel);
    const customerKey = (panel && panel.dataset.searchCustomerKey) || 'guest';
    const STORAGE_KEY = 'gabriel-recent-searches:' + customerKey;
    const MAX_RECENT_SEARCHES = 6;
    const SEARCH_DEBOUNCE = 220;
    const MIN_SEARCH_LENGTH = 2;
    const searchRoot = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    let searchTimer = null;
    let activeRequest = null;
    let lastSearchTerm = '';

    if (
      !panel ||
      !input ||
      !form ||
      !recentSection ||
      !recentList ||
      !recentEmptyMessage ||
      !liveSection ||
      !liveCount ||
      !liveLoading ||
      !liveStatus ||
      !liveProductBlock ||
      !liveProductList
    )
      return;

    function formatPredictiveMoney(value) {
      const amount = Number.parseFloat(value || 0);
      return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(amount);
    }

    function setDefaultSectionsVisible(isVisible) {
      defaultSections.forEach(function (section) {
        if (section === recentSection && isVisible) return;
        section.hidden = !isVisible;
      });
    }

    function setElementHidden(element, isHidden) {
      if (!element) return;
      element.hidden = isHidden;
      if (isHidden) {
        element.setAttribute('hidden', '');
      } else {
        element.removeAttribute('hidden');
      }
    }

    function resetLiveResults() {
      setElementHidden(liveSection, true);
      setElementHidden(liveCount, true);
      liveCount.textContent = '';
      setElementHidden(liveLoading, true);
      setElementHidden(liveStatus, true);
      liveStatus.textContent = '';
      setElementHidden(liveProductBlock, true);
      liveProductList.innerHTML = '';
    }

    function getRecentSearches() {
      try {
        const stored = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        return stored.filter(function (term) {
          return typeof term === 'string' && term.trim();
        });
      } catch (error) {
        return [];
      }
    }

    function saveRecentSearches(terms) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(terms));
      } catch (error) {}
    }

    function normalizeSearchTerm(term) {
      return String(term || '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function rememberSearch(term) {
      const normalized = normalizeSearchTerm(term);
      if (!normalized || normalized.length < 2) return;

      const nextTerms = getRecentSearches().filter(function (entry) {
        return entry.toLocaleLowerCase('de-DE') !== normalized.toLocaleLowerCase('de-DE');
      });

      nextTerms.unshift(normalized);
      saveRecentSearches(nextTerms.slice(0, MAX_RECENT_SEARCHES));
      renderRecentSearches();
    }

    function renderRecentSearches() {
      const terms = getRecentSearches();

      if (!terms.length) {
        recentList.innerHTML = '';
        recentEmptyMessage.hidden = false;
        recentSection.hidden = false;
        return;
      }

      recentList.innerHTML = terms
        .map(function (term) {
          const href = '/search?type=product&q=' + encodeURIComponent(term);
          return '<a href="' + href + '" class="search-offcanvas__chip">' + escapeHtml(term) + '</a>';
        })
        .join('');

      recentEmptyMessage.hidden = true;
      recentSection.hidden = false;
    }

    function renderLiveResults(term, payload) {
      const results = (payload && payload.resources && payload.resources.results) || {};
      const products = Array.isArray(results.products) ? results.products : [];

      setElementHidden(liveSection, false);
      setElementHidden(liveLoading, true);
      liveProductList.innerHTML = '';
      liveCount.textContent = products.length === 1 ? '1 Treffer' : products.length + ' Treffer';
      setElementHidden(liveCount, products.length === 0);

      if (!products.length) {
        liveStatus.textContent = 'Keine Treffer für „' + term + '“.';
        setElementHidden(liveStatus, false);
        setElementHidden(liveProductBlock, true);
        return;
      }

      setElementHidden(liveStatus, true);
      liveProductList.innerHTML = products
        .map(function (product) {
          const image = product.image || '';
          return (
            '<a href="' +
            escapeHtml(product.url) +
            '" class="search-offcanvas__product" data-live-search-link>' +
            '<div class="search-offcanvas__product-image-wrap">' +
            (image
              ? '<img src="' +
                escapeHtml(image) +
                '" alt="' +
                escapeHtml(product.title) +
                '" class="search-offcanvas__product-image" width="160" height="160" loading="lazy">'
              : '<div class="search-offcanvas__product-placeholder"></div>') +
            '</div>' +
            '<span class="search-offcanvas__product-title">' +
            escapeHtml(product.title) +
            '</span>' +
            '<span class="search-offcanvas__product-price">' +
            formatPredictiveMoney(product.price) +
            '</span>' +
            '</a>'
          );
        })
        .join('');
      setElementHidden(liveProductBlock, false);
    }

    function fetchPredictiveResults(term) {
      if (normalizeSearchTerm(term).length < MIN_SEARCH_LENGTH) {
        setDefaultSectionsVisible(true);
        resetLiveResults();
        renderRecentSearches();
        return Promise.resolve();
      }

      if (activeRequest && typeof activeRequest.abort === 'function') {
        activeRequest.abort();
      }

      activeRequest = typeof AbortController !== 'undefined' ? new AbortController() : null;

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product',
        'resources[limit]': '3',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'hide',
      });

      setElementHidden(liveSection, false);
      setElementHidden(liveCount, true);
      setElementHidden(liveLoading, false);
      setElementHidden(liveStatus, true);
      setElementHidden(liveProductBlock, true);

      return fetch(searchRoot + 'search/suggest.json?' + params.toString(), {
        signal: activeRequest ? activeRequest.signal : undefined,
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Predictive search failed: ' + response.status);
          }
          return response.json();
        })
        .then(function (payload) {
          if (term !== lastSearchTerm) return;
          renderLiveResults(term, payload);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          setElementHidden(liveSection, false);
          setElementHidden(liveCount, true);
          setElementHidden(liveLoading, true);
          liveStatus.textContent = 'Die Suche ist gerade nicht verfügbar.';
          setElementHidden(liveStatus, false);
          setElementHidden(liveProductBlock, true);
        });
    }

    function handleLiveSearch() {
      const term = normalizeSearchTerm(input.value);
      lastSearchTerm = term;

      if (searchTimer) {
        clearTimeout(searchTimer);
      }

      if (term.length < MIN_SEARCH_LENGTH) {
        if (activeRequest && typeof activeRequest.abort === 'function') {
          activeRequest.abort();
        }
        activeRequest = null;
        setDefaultSectionsVisible(true);
        resetLiveResults();
        renderRecentSearches();
        return;
      }

      setDefaultSectionsVisible(false);
      searchTimer = setTimeout(function () {
        fetchPredictiveResults(term);
      }, SEARCH_DEBOUNCE);
    }

    function rememberCurrentSearchFromUrl() {
      if (!window.location.pathname.includes('/search')) return;
      const params = new URLSearchParams(window.location.search);
      const query = params.get('q');
      if (query) rememberSearch(query);
    }

    form.addEventListener('submit', function () {
      rememberSearch(input.value);
    });

    panel.addEventListener('click', function (event) {
      if (event.target.closest('[data-live-search-link]')) {
        rememberSearch(input.value);
      }
    });

    input.addEventListener('input', handleLiveSearch);
    input.addEventListener('search', handleLiveSearch);

    rememberCurrentSearchFromUrl();
    renderRecentSearches();
    resetLiveResults();

    document.addEventListener('site:offcanvas:open', function (e) {
      if (e.detail.name === 'search') {
        input.value = '';
        lastSearchTerm = '';
        if (searchTimer) {
          clearTimeout(searchTimer);
          searchTimer = null;
        }
        if (activeRequest && typeof activeRequest.abort === 'function') {
          activeRequest.abort();
        }
        activeRequest = null;
        renderRecentSearches();
        setDefaultSectionsVisible(true);
        resetLiveResults();
        setTimeout(function () {
          input.focus();
        }, 80);
      }
    });
  }

  // ============================================================
  // 9. PRODUCT PAGE: IMAGE GALLERY
  // ============================================================
  function initProductGallery() {
    const mainImg = $('#main-img');
    const thumbs = $$('.product-page__thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
        mainImg.src = thumb.dataset.src;
      });
    });
  }

  // ============================================================
  // 10. WISHLIST (localStorage)
  // ============================================================
  function initWishlist(offcanvas) {
    const STORAGE_KEY = 'gabriel-wishlist';
    const itemsEl = $('#wishlist-offcanvas-items');
    const emptyEl = $('#wishlist-offcanvas-empty');
    const benefitsEl = $('#wishlist-offcanvas-benefits');
    const footerEl = $('#wishlist-offcanvas-footer');
    const titleCountEl = $('[data-wishlist-title-count]');
    const footerCountEl = $('[data-wishlist-footer-count]');
    const countEls = $$('[data-wishlist-count]');

    function getWishlist() {
      try {
        const list = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        return list.filter(function (item) {
          return item && typeof item === 'object' && item.handle;
        });
      } catch (e) {
        return [];
      }
    }

    function saveWishlist(list) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (e) {}
    }

    function updateCounts(list) {
      countEls.forEach(function (el) {
        el.textContent = String(list.length);
        if (list.length > 0) el.removeAttribute('hidden');
        else el.setAttribute('hidden', '');
      });

      if (titleCountEl) {
        titleCountEl.textContent = list.length ? '(' + list.length + ')' : '';
      }

      if (footerCountEl) {
        footerCountEl.textContent = String(list.length);
      }
    }

    function getEntryFromButton(btn) {
      return {
        id: btn.dataset.wishlistId || '',
        handle: btn.dataset.wishlistHandle || btn.dataset.wishlist || '',
        title: btn.dataset.wishlistTitle || '',
        type: btn.dataset.wishlistType || '',
        url: btn.dataset.wishlistUrl || '#',
        image: btn.dataset.wishlistImage || '',
        price: Number(btn.dataset.wishlistPrice || 0),
        variantId: btn.dataset.wishlistVariantId || '',
        available: btn.dataset.wishlistAvailable === 'true',
      };
    }

    function renderWishlist() {
      if (!itemsEl) return;

      const wishlist = getWishlist();
      updateCounts(wishlist);

      if (!wishlist.length) {
        itemsEl.innerHTML = '';
        itemsEl.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (benefitsEl) benefitsEl.hidden = false;
        if (footerEl) footerEl.hidden = true;
        return;
      }

      itemsEl.hidden = false;
      if (emptyEl) emptyEl.hidden = true;
      if (benefitsEl) benefitsEl.hidden = true;
      if (footerEl) footerEl.hidden = false;

      itemsEl.innerHTML = wishlist
        .map(function (item) {
          return `
            <div class="wishlist-offcanvas__item" data-wishlist-item="${escapeHtml(item.handle)}">
              <div class="wishlist-offcanvas__item-top">
                <a href="${escapeHtml(item.url)}" class="wishlist-offcanvas__image-wrap">
                  ${
                    item.image
                      ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" class="wishlist-offcanvas__image" width="96" height="96" loading="lazy">`
                      : '<div class="wishlist-offcanvas__image-placeholder"></div>'
                  }
                </a>
                <div class="wishlist-offcanvas__copy">
                  <p class="wishlist-offcanvas__eyebrow">${escapeHtml(item.type || 'Schmuck')}</p>
                  <a href="${escapeHtml(item.url)}" class="wishlist-offcanvas__name">${escapeHtml(item.title)}</a>
                  <p class="wishlist-offcanvas__price">${formatDrawerMoney(item.price)}</p>
                </div>
                <button type="button" class="wishlist-offcanvas__remove" data-wishlist-remove="${escapeHtml(item.handle)}" aria-label="Entfernen">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
                </button>
              </div>
              <div class="wishlist-offcanvas__actions">
                <button type="button" class="btn btn--primary wishlist-offcanvas__cart-btn" data-wishlist-cart="${escapeHtml(item.handle)}" ${item.available && item.variantId ? '' : 'disabled'}>
                  In den Warenkorb
                </button>
                <a href="${escapeHtml(item.url)}" class="btn btn--outline wishlist-offcanvas__details-btn">Details</a>
              </div>
            </div>
          `;
        })
        .join('');
    }

    function syncButtons() {
      const wishlist = getWishlist();
      $$('[data-wishlist]').forEach(function (btn) {
        const handle = btn.dataset.wishlistHandle || btn.dataset.wishlist;
        const isActive = wishlist.some(function (item) {
          return item.handle === handle;
        });
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      });

      updateCounts(wishlist);
    }

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('[data-wishlist]');
      if (btn) {
        e.stopPropagation();
        const entry = getEntryFromButton(btn);
        const wishlist = getWishlist();
        const idx = wishlist.findIndex(function (item) {
          return item.handle === entry.handle;
        });

        if (idx === -1) wishlist.push(entry);
        else wishlist.splice(idx, 1);

        saveWishlist(wishlist);
        syncButtons();
        renderWishlist();
        return;
      }

      const removeBtn = e.target.closest('[data-wishlist-remove]');
      if (removeBtn) {
        const handle = removeBtn.dataset.wishlistRemove;
        const wishlist = getWishlist().filter(function (item) {
          return item.handle !== handle;
        });
        saveWishlist(wishlist);
        syncButtons();
        renderWishlist();
        return;
      }

      const addToCartBtn = e.target.closest('[data-wishlist-cart]');
      if (addToCartBtn) {
        const handle = addToCartBtn.dataset.wishlistCart;
        const item = getWishlist().find(function (entry) {
          return entry.handle === handle;
        });
        if (!item || !item.variantId) return;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.variantId, quantity: 1 }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            offcanvas.open('cart');
          })
          .catch(function (err) {
            console.error('Wishlist add to cart error', err);
          });
        return;
      }

      const addAllBtn = e.target.closest('[data-wishlist-add-all]');
      if (addAllBtn) {
        const items = getWishlist()
          .filter(function (item) {
            return item.available && item.variantId;
          })
          .map(function (item) {
            return { id: Number(item.variantId), quantity: 1 };
          });

        if (!items.length) return;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function () {
            offcanvas.open('cart');
          })
          .catch(function (err) {
            console.error('Wishlist bulk add error', err);
          });
      }
    });

    document.addEventListener('site:offcanvas:open', function (e) {
      if (e.detail.name === 'wishlist') {
        renderWishlist();
      }
    });

    syncButtons();
    renderWishlist();
  }

  // ============================================================
  // 11. PRODUCT VARIANT SELECTION
  // ============================================================
  function initVariantSelection() {
    const optionBtns = $$('.pdp__option-btn, .product-form__option-btn');
    const optionSelects = $$('[data-option-select]');
    const hiddenInput = $('#pdp-variant-id') || $('input[name="id"]');
    const priceContainer = $('[data-pdp-price]');
    const stockElement = $('[data-pdp-stock]');
    const stockText = $('[data-pdp-stock-text]');
    const atcButton = $('#pdp-atc');
    const wishlistButton = $('[data-wishlist-button]');
    const variantDataElement = $('#pdp-variant-data');
    if (!optionBtns.length && !optionSelects.length) return;

    let variants = [];

    if (variantDataElement) {
      try {
        variants = JSON.parse(variantDataElement.textContent);
      } catch (error) {
        variants = [];
      }
    }

    function getOptionPosition(btn) {
      return btn.dataset.option || btn.dataset.optionPosition;
    }

    function getSelectedOptions() {
      const selected = [];

      optionSelects.forEach(function (select) {
        const position = Number(select.dataset.option);
        if (!position) return;

        selected[position - 1] = select.value;
      });

      optionBtns.forEach(function (btn) {
        if (!btn.classList.contains('is-selected')) return;

        const position = Number(getOptionPosition(btn));
        if (!position) return;

        selected[position - 1] = btn.dataset.value;
      });

      return selected;
    }

    function findVariant() {
      if (!variants.length) return null;

      const selected = getSelectedOptions();

      return (
        variants.find(function (variant) {
          return [variant.option1, variant.option2, variant.option3].every(function (value, index) {
            return !selected[index] || value === selected[index];
          });
        }) || null
      );
    }

    function renderPriceMarkup(variant) {
      if (!variant) return '';

      if (variant.compare_at_price > variant.price) {
        return (
          '<span class="price price--on-sale">' +
          '<span class="price__current">' +
          escapeHtml(variant.price_formatted) +
          '</span>' +
          '<s class="price__compare">' +
          escapeHtml(variant.compare_at_price_formatted) +
          '</s>' +
          '</span>'
        );
      }

      return (
        '<span class="price' +
        (variant.available ? '' : ' price--sold') +
        '">' +
        escapeHtml(variant.price_formatted) +
        '</span>'
      );
    }

    function updateButtonState(position, activeButton) {
      optionBtns.forEach(function (button) {
        if (String(getOptionPosition(button)) !== String(position)) return;

        const isSelected = button === activeButton;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function updateButtonStateByValue(position, value) {
      optionBtns.forEach(function (button) {
        if (String(getOptionPosition(button)) !== String(position)) return;

        const isSelected = button.dataset.value === value;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
    }

    function updateSelectState(position, value) {
      optionSelects.forEach(function (select) {
        if (String(select.dataset.option) !== String(position)) return;
        if (select.value !== value) {
          select.value = value;
        }
      });
    }

    function applyVariant(variant, updateUrl) {
      if (!variant) {
        if (hiddenInput) hiddenInput.value = '';
        if (priceContainer) priceContainer.innerHTML = '';
        if (stockElement) stockElement.classList.remove('pdp__stock--in');
        if (stockElement) stockElement.classList.add('pdp__stock--out');
        if (stockText) stockText.textContent = 'Nicht verfügbar';
        if (atcButton) {
          atcButton.disabled = true;
          atcButton.textContent = 'Ausverkauft';
        }
        document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variant: null } }));
        return;
      }

      if (hiddenInput) hiddenInput.value = variant.id;
      if (priceContainer) priceContainer.innerHTML = renderPriceMarkup(variant);

      if (stockElement) {
        stockElement.classList.toggle('pdp__stock--in', variant.available);
        stockElement.classList.toggle('pdp__stock--out', !variant.available);
      }

      if (stockText) {
        stockText.textContent = variant.available ? 'Auf Lager' : 'Ausverkauft';
      }

      if (atcButton) {
        atcButton.disabled = !variant.available;
        atcButton.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }

      if (wishlistButton) {
        wishlistButton.dataset.variantId = variant.id;
      }

      if (updateUrl && variant.url && window.history && window.history.replaceState) {
        window.history.replaceState({}, '', variant.url);
      }

      document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variant: variant } }));
    }

    optionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const position = getOptionPosition(btn);
        if (!position) return;

        updateButtonState(position, btn);
        updateSelectState(position, btn.dataset.value);
        applyVariant(findVariant(), true);
      });
    });

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        const position = select.dataset.option;
        if (!position) return;

        updateButtonStateByValue(position, select.value);
        applyVariant(findVariant(), true);
      });
    });

    applyVariant(findVariant(), false);
  }

  // ============================================================
  // 12. GOOGLE REVIEWS — pause on hover handled by CSS
  //     Track width correction based on actual card count
  // ============================================================
  function initReviewsTrack() {
    const track = $('[data-reviews-track]');
    if (!track) return;
    // CSS animation handles the scroll; just ensure no jank on low-end devices
  }

  // ============================================================
  // 14. MAIN INIT
  // ============================================================
  function init() {
    const offcanvas = createOffcanvasController();
    initStickyHeader();
    initMobileMenu();
    initMegaMenu();
    initHeroSlider();
    initScrollAnimations();
    initCartDrawer(offcanvas);
    initSearchOffcanvas();
    initProductGallery();
    initWishlist(offcanvas);
    initVariantSelection();
    initReviewsTrack();
    // announcement bar removed;
    initWhatsAppForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   WhatsApp Form — exclusive submission channel
   Submit is prevented; WhatsApp opens with pre-filled message.
   User sees a notice; form is NOT forwarded to Shopify.
============================================================ */
function initWhatsAppForms() {
  const WA_NUMBER = document.body?.dataset.whatsappNumber || '491724995000';

  const FIELD_LABELS = {
    vorname: 'Vorname',
    nachname: 'Nachname',
    email: 'E-Mail',
    telefon: 'Telefon',
    betreff: 'Betreff',
    body: 'Nachricht',
    marke: 'Marke',
    modell: 'Modell',
    referenz: 'Referenznummer',
    zustand: 'Zustand',
    budget: 'Budget',
    kategorie: 'Kategorie',
    beschreibung: 'Beschreibung',
    preisvorstellung: 'Preisvorstellung',
    zubehoer: 'Zubehör',
    name: 'Name',
    jahrgang: 'Jahrgang',
    material: 'Material',
  };

  function getFormTitle(form) {
    if (form.id === 'contact-form' || form.classList.contains('contact__form')) {
      return '📩 Kontaktanfrage – GABRIEL';
    }
    if (form.classList.contains('ankauf__form')) {
      return '💎 Ankaufsanfrage – GABRIEL';
    }
    if (form.classList.contains('sourcing__form')) {
      return '🔍 Sourcing-Anfrage – GABRIEL';
    }
    return '📩 Anfrage – GABRIEL';
  }

  function buildMessage(form) {
    const title = getFormTitle(form);
    const lines = [title, '─────────────────'];
    const data = new FormData(form);

    const seen = new Set();
    for (const [key, val] of data.entries()) {
      const match = key.match(/^contact\[(.+)\]$/);
      if (!match || seen.has(match[1])) continue;
      seen.add(match[1]);
      const fieldKey = match[1];
      const label = FIELD_LABELS[fieldKey] || fieldKey.charAt(0).toUpperCase() + fieldKey.slice(1);
      const value = (val || '').toString().trim();
      if (value) lines.push(`*${label}:* ${value}`);
    }

    lines.push('─────────────────');
    lines.push('Gesendet über gabriel-uhren.de');
    return lines.join('\n');
  }

  function getOrCreateNotice(form) {
    let notice = form.querySelector('.wa-form-notice');
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'wa-form-notice';
      // insert before the submit button row
      const footer = form.querySelector(
        '.contact__form-footer, .ankauf__form-footer, .sourcing__form-footer, [class*="form-footer"]',
      );
      if (footer) {
        form.insertBefore(notice, footer);
      } else {
        form.appendChild(notice);
      }
    }
    return notice;
  }

  function showNotice(form, waUrl) {
    const notice = getOrCreateNotice(form);
    notice.innerHTML =
      '<div class="wa-form-notice__icon">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>' +
      '</div>' +
      '<div class="wa-form-notice__body">' +
      '<strong>WhatsApp wurde geöffnet</strong>' +
      '<p>Bitte senden Sie die vorgefertigte Nachricht in WhatsApp, um Ihre Anfrage abzuschließen.</p>' +
      '<button type="button" class="wa-form-notice__retry">Erneut öffnen &rarr;</button>' +
      '</div>';
    notice.classList.add('wa-form-notice--visible');

    notice.querySelector('.wa-form-notice__retry').addEventListener('click', function () {
      window.open(waUrl, '_blank', 'noopener,noreferrer');
    });
  }

  function attachWhatsApp(form) {
    if (!form || form.dataset.waAttached) return;
    form.dataset.waAttached = '1';

    form.addEventListener('submit', function (e) {
      // Always prevent Shopify submission — WhatsApp is the only channel
      e.preventDefault();

      const msg = buildMessage(form);
      const url = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(msg);

      window.open(url, '_blank', 'noopener,noreferrer');
      showNotice(form, url);
    });
  }

  document.querySelectorAll('#contact-form, .ankauf__form, .sourcing__form').forEach(attachWhatsApp);
}
